export enum BlexonResolutionType {
	Unknown = 0,
	Declined = 1,
	AcceptedErsatzlieferung = 2,
	AcceptedNacharbeit = 3,
	AcceptedDiscount = 4,
}

export const blexonResolutionTypes = [
	{
		name: "Beanstandung ablehnen",
		value: BlexonResolutionType.Declined,
	},
	{
		name: "Ersatzlieferung",
		value: BlexonResolutionType.AcceptedErsatzlieferung,
	},
	{
		name: "Nacharbeit",
		value: BlexonResolutionType.AcceptedNacharbeit,
	},
	{
		name: "Gutschrift",
		value: BlexonResolutionType.AcceptedDiscount,
	},
];
